import { normalizeCountryCode } from './country-code'

export const isAiLearningAvailableForCountry = (countryCode?: string | null) =>
  normalizeCountryCode(countryCode) === 'KR'
